import { axiosInstance } from "../axiosInstance";
export function loadCheckoutScript(params) {
  return new Promise((resolve) => {
    if (document.getElementById("razorpay_checkout_script_93jjd80m") !== null) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.id = "razorpay_checkout_script_93jjd80m";
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

export async function getEstimateDetails(data) {
  return axiosInstance({
    url: "customer_estimate_flow_service.php",
    method: "post",
    data: data,
  });
}

export async function generatePaymentOrder(params) {
  return axiosInstance({
    url: "payment.php",
    method: "post",
    data: params,
  });
}

export async function notifyPayment(data) {
  return axiosInstance({
    url: "razorpay_notify.php",
    method: "post",
    data: data,
  });
}
